import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useActions, useAppSelector, AutoReplyActions } from '@web-common/state/createStore';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { getIn18Text, inWindow, apiHolder as api, apis } from 'api';
const autoReplyApi = api.api.requireLogicalApi(apis.autoReplyApiImpl);
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
const AutoReplyTips = (props) => {
    const [mailSearching] = useState2RM('mailSearching');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const [autoReplyTip, setAutoReplyTip] = useState(false);
    const { updateAutoReplyDetail } = useActions(AutoReplyActions);
    const autoReplyDetail = useAppSelector(state => state.autoReplyReducer.autoReplyDetail);
    const closeAutoReplyTips = useCallback((e) => {
        setAutoReplyTip(false);
        inWindow() && window.localStorage.setItem('autoReplyTip', '1');
        e.stopPropagation();
    }, []);
    const closeAutoReply = useDebounceForEvent(() => {
        autoReplyApi
            .updateMailRulesByAutoReply(Object.assign(Object.assign({}, autoReplyDetail), { disabled: true }))
            .then(suc => {
            if (suc) {
                setAutoReplyTip(false);
                updateAutoReplyDetail(Object.assign(Object.assign({}, autoReplyDetail), { disabled: true }));
                SiriusMessage.success({
                    content: getIn18Text('YIGUANBIZIDONG'),
                });
            }
        })
            .catch(() => {
            SiriusMessage.error({
                content: getIn18Text('GUANBIZIDONGHUI11'),
            });
        });
    });
    useEffect(() => {
        const tips = inWindow() && window.localStorage.getItem('autoReplyTip');
        if (Object.keys(autoReplyDetail).length > 0 && !autoReplyDetail.disabled && !tips) {
            setAutoReplyTip(true);
        }
        else {
            setAutoReplyTip(false);
        }
    }, [autoReplyDetail]);
    const AutoReplyMailListTip = useMemo(() => {
        var _a;
        const tips = inWindow() && window.localStorage.getItem('autoReplyTip');
        let timeout = false;
        if ((_a = autoReplyDetail === null || autoReplyDetail === void 0 ? void 0 : autoReplyDetail.moments) === null || _a === void 0 ? void 0 : _a.endTime) {
            try {
                timeout = autoReplyDetail.moments.endTime.isAfter(new Date());
            }
            catch (e) {
                console.error(e);
            }
        }
        if (!timeout && Object.keys(autoReplyDetail).length > 0 && !autoReplyDetail.disabled && !tips && !isSearching && autoReplyTip) {
            return (React.createElement("div", { className: "u-auto" },
                React.createElement("div", { className: "u-auto-title" }, getIn18Text('DANGQIANYIQIYONG')),
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement("span", { className: "u-auto-text", onClick: closeAutoReply }, getIn18Text('GUANBIZIDONGHUI')),
                    React.createElement("div", { className: "u-auto-btn", onClick: closeAutoReplyTips }))));
        }
        return React.createElement(React.Fragment, null);
    }, [autoReplyDetail, isSearching, autoReplyTip]);
    return AutoReplyMailListTip;
};
export default AutoReplyTips;
